import styled from 'styled-components'
import { color } from '../../../GlobalStyle'
import { breakpoints } from '../../../MediasQueries'

export const ContainerTable = styled.div`
  margin: 0 0 2vh 0;
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight};
  overflow-y:auto;
  #infos {
    font-weight: 100;
    color: rgba(0,0,0,0.62);
    font-size: 13px;
    padding-left:5px;
 
}
  }
  @media screen and (max-width: ${breakpoints.lg}) {
    .check {
      height: 20px;
    }
    table thead {
     display:none;
    }
    table tr {
      border-bottom: 3px solid #e1e5e9;
     
      display: block;
      margin-bottom: .625em;
    }
    table th,
    table td {
      padding: 0.625em!important;
    }
    table td {
      border-bottom: 1px solid #e1e5e9;
      display: block;
      text-align: right;
      font-size: 16px;
      position: relative;
      
     
    }
    table td::before {
      display: table-cell;
      vertical-align: middle;
      content: attr(data-label);
      float: left;
      font-weight: bold;
     
      vertical-align:bottom;
      color: #000;
    }
    table td:last-child {
      border-bottom: 0;
    }
   
`

export const ProductTable = styled.table`
  text-transform: capitalize;
  text-align: justify;
  border-spacing: 0px;
  width: 100%;
  padding: 15px;
  padding: ${(props) => props.padding};
  td:first-of-type,
  th:first-of-type {
    padding-left: 1.2vw;
  }
  td:last-of-type,
  th:last-of-type {
    padding-right: 1.2vw;
  }
  td {
    white-space: nowrap;
    padding: 8px 0px;
  }
  tr:nth-of-type(1) {
    td {
      padding-top: 20px;
    }
  }

  @media (max-width: ${breakpoints.lg}) {
    .all {
      padding: 0.825em !important;
      display: flex;
      span:nth-of-type(1) {
        order: 4;
        text-align: initial;
      }
    }
  }
`
export const TableHead = styled.thead`
  font-size: 14px;
  th {
    position: sticky;
    top: 0;
  }
`

export const selectedDiv = styled.div`
  display: flex;
`
export const TableBody = styled.tr`
  font-size: 18px;

  td:nth-of-type(1) {
    font-weight: bold;
  }

  td:nth-of-type(6),
  td:nth-of-type(5) {
    color: ${color.brand};
    font-weight: bold;
  }
  .actions {
    white-space: nowrap;
  }
`
export const Actions = styled.div`
  display: flex;
  align-items: center;
`

export const SelectQtd = styled.div`
  display: grid;
  gap: 5px;
  grid-template-columns: 1fr 1.4fr;
`
